import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChunkyRibKnitBlack = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.ChunkyRibKnitBlack.itemName}
      name={AW23.tops.ChunkyRibKnitBlack.itemName}
      price={AW23.tops.ChunkyRibKnitBlack.itemPrice}
      fabric={AW23.tops.ChunkyRibKnitBlack.itemFabric}
      src={AW23.tops.ChunkyRibKnitBlack.sizeChart}
      divId={AW23.tops.ChunkyRibKnitBlack.shopifyDivId}
      mainId={AW23.tops.ChunkyRibKnitBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.ChunkyRibKnitBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.ChunkyRibKnitBlack.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChunkyRibKnitBlack;
